import React, { Component } from 'react';



class Comment extends Component {



    render() {

        return (
            <div className="comment">
                    {this.props.text}
            </div>

        );
    }
}

export default Comment;



// WEBPACK FOOTER //
// ./src/components/comments.js